<script lang="ts">
	import { push } from 'svelte-spa-router';

	import { Text, ButtonV2, VerificationCode, Icon } from '@Shelly/shelly-design-system';
	import { tempUserData } from 'src/stores/account/user';

	import { format } from 'svelte-i18n';

	let codeValue = '';
	let finish = false;
</script>

{#if !finish}
	<Text element="h1" class="mb-xl pl-s">E-Mail Verification</Text>
	<Text styleType="body" class="text-center mb-m">
		{`Enter the code we have sent you to your e-mail ${$tempUserData.email} to verify
		your account.`}
	</Text>

	<VerificationCode
		id="verificationcode-0q2k1gj"
		class="mb-m"
		value={codeValue}
		a11yProps={{
			fieldsAriaLabel: [
				$format('label_verification_code_digit', { default: 'Verification code digit 1' }),
				$format('label_verification_code_digit', { default: 'Verification code digit 2' }),
				$format('label_verification_code_digit', { default: 'Verification code digit 3' }),
				$format('label_verification_code_digit', { default: 'Verification code digit 4' }),
				$format('label_verification_code_digit', { default: 'Verification code digit 5' }),
				$format('label_verification_code_digit', { default: 'Verification code digit 6' }),
			],
		}}
		on:value_change={(event) => {
			codeValue = event.detail.value;
			console.log(codeValue, ' ~~~value change');
		}}
	/>

	<Text styleType="body-small" class="text-center mb-m">
		Didn’t receive code?
		<span
			class="link-styles hover-opacity"
			style="font-size: inherit; line-height: inherit;"
			role="presentation"
			on:click={(e) => {
				e.preventDefault();
				console.log('Resend click');
			}}
		>
			Resend
		</span>
	</Text>

	<ButtonV2
		variant="primary"
		width="full"
		on:click={() => {
			finish = true;
		}}
	>
		Submit
	</ButtonV2>

	<hr class="mt-xl mb-xl" />

	<ButtonV2
		variant="secondary"
		width="full"
		on:click={() => {
			push('/change-email');
		}}
	>
		Change E-mail
	</ButtonV2>
{:else}
	<div class="text-center mb-m">
		<Icon icon="fat fa-envelope-circle-check text-success" size="l" />
	</div>
	<Text element="h1" class="text-center mb-m pl-s">E-mail Verified Successfully.</Text>
	<Text class="text-center mb-m">You can now enjoy the Shelly app by clicking the button below.</Text>
	<ButtonV2
		width="full"
		on:click={() => {
			push('/login');
		}}
	>
		Continue
	</ButtonV2>
{/if}
